module.exports = __webpack_public_path__ + "static/img/4-2.99d463fb.png";